import React from 'react';
import { Route } from 'react-router-dom';
import Seekers from 'components/seekers';

const routes = [
  <Route key="seekers" path="/seekers" exact><Seekers/></Route>
];

export default routes;
